'use client';

import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const ReferenceCardHover = ({
  reference,
}: {
  reference: {
    slug: string;
  };
}) => {
  const { t } = useTranslations();

  return (
    <div className={cn('', 'ea-reference-card-hover__box')}>
      <Button asChild className={cn('', 'ea-reference-card-hover__button')}>
        <Link href={`/referencie/${reference?.slug}`}>{t('text808')}</Link>
      </Button>
    </div>
  );
};
